document.addEventListener('DOMContentLoaded', function() {
  var triggers = document.querySelectorAll('.utility-bar__dropdown-trigger');
  triggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = trigger.classList.contains('open');
      document.querySelectorAll('.utility-bar__dropdown-trigger.open').forEach(function(openTrigger) {
        openTrigger.classList.remove('open');
      });
      if (!isOpen) {
        trigger.classList.add('open');
      }
    });
  });
  document.addEventListener('click', function() {
    document.querySelectorAll('.utility-bar__dropdown-trigger.open').forEach(function(trigger) {
      trigger.classList.remove('open');
    });
  });
}); 